import global$1 from './global.js';
import toIntegerOrInfinity$1 from './to-integer-or-infinity.js';

var global = global$1;
var toIntegerOrInfinity = toIntegerOrInfinity$1;
var RangeError = global.RangeError;

var toPositiveInteger = function (it) {
  var result = toIntegerOrInfinity(it);
  if (result < 0) throw RangeError("The argument can't be less than 0");
  return result;
};

export { toPositiveInteger as default };
